import PropTypes from "prop-types";
import React, { Fragment } from "react";
import styles from "./feeds-seo-faq.css";

function FeedsSeoFaq({ faq }) {
    let title = null;
    if (faq.title) {
        title = <h3>{faq.title}</h3>;
    }

    let items = null;
    if (faq.items.length > 0) {
        items = (
            <dl>
                {faq.items.map((item, index) => {
                    if (item.title || item.body) {
                        return (
                            <Fragment key={index}>
                                <dt className={styles.faqTitle}>{item.title}</dt>
                                <dd
                                    className={styles.faqText}
                                    dangerouslySetInnerHTML={{ __html: item.body }}
                                ></dd>
                            </Fragment>
                        );
                    }
                })}
            </dl>
        );
    }

    if (title || items) {
        return (
            <div className={styles.faq}>
                {title}
                {items}
            </div>
        );
    }

    return null;
}

FeedsSeoFaq.propTypes = {
    faq: PropTypes.shape({
        title: PropTypes.string,
        items: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                body: PropTypes.string,
            })
        ),
    }),
};

export default FeedsSeoFaq;
